import React from "react";
import Link from 'next/link';
import classNames from "classnames";
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic'

import useSWR from 'swr'
import { makeStyles } from "@material-ui/core/styles";
import Loading from 'components/Functions/Loading';
import Message from 'components/Functions/Message';

const Footer = dynamic(() => import('/components/Footer/Footer.js'));

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";
const styles = {
  ...landingPage,
  main: {
    background: "#f1f5f8",
    position: "relative",
    zIndex: "3",
    paddingTop: "30px",
  }
};

// Sections for this page
import HeaderSection from "pages-sections/HeaderSection.js";
const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'), { loading: <Loading /> });
const GridItem = dynamic(() => import('/components/Grid/GridItem.js'));
const ProductSection = dynamic(() => import('pages-sections/ProductSection.js'), { ssr: true, loading: () => <Loading /> });
const Button = dynamic(() => import('/components/CustomButtons/Button.js'));

const SEO = {
  title: "BB Host - VPS",
  description: "Servidores de alta disponibilidade em hardware dedicado e alta capacidade de escalonamento.",
  url: "https://www.bbhost.com.br/vps",
  type: "website",
  languageAlternates: [
    {
      hrefLang: 'en',
      href: "https://www.bbhost.com.br/en/vps",
    },
    {
      hrefLang: 'es',
      href: "https://www.bbhost.com.br/es/vps",
    }
  ],
};
import { trans } from "lang/lang.js";

const useStyles = makeStyles(styles);

const fetcher = (url) => fetch(url).then((res) => res.json());

export default function VPS(props) {
  const classes = useStyles();
  const { locale, defaultLocale } = useRouter();
  const BareMetalRoute = (locale === defaultLocale) ? "/baremetal" : `/${locale}/baremetal`;
  const ColocationRoute = (locale === defaultLocale) ? "/colocation" : `/${locale}/colocation`;
  const { data: dataVPS } = useSWR('https://api-frontend-site.bbhost.com.br/products-vps', fetcher)
  let products_tab = <Loading />;

  if(dataVPS !== undefined) {
    products_tab = (<ProductSection name="vps" products={dataVPS.products} locale={{ locale, defaultLocale }} />);
  }

  if(dataVPS !== undefined && dataVPS.outStockAll)
  {
    return (
      <div>
        <HeaderSection name="vps" seo={SEO} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <GridContainer justifyContent="center" alignItems="center">
              <GridItem xs={12} sm={12} md={8}>
                <Message>
                  {trans(`products::outStockAll.title`)}
                </Message>
                <Message>
                  {trans(`products::outStockAll.subTitle`)}
                </Message>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={12} sm={12} md={4}>
                    <Link href={BareMetalRoute} as={BareMetalRoute} passHref>
                      <Button color="info" block>
                        BareMetal
                      </Button>
                    </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Link href={ColocationRoute} as={ColocationRoute} passHref>
                      <Button color="info" block>
                        Colocation
                      </Button>
                    </Link>
                  </GridItem>
                </GridContainer> 
              </GridItem>
            </GridContainer>
            <GridContainer justifyContent="center" alignItems="center" style={{paddingTop: "20px"}}>
              <GridItem xs={12} sm={12} md={12}>
                {products_tab}
              </GridItem>            
            </GridContainer>        
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <HeaderSection name="vps" seo={SEO} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          {products_tab}
        </div>
      </div>
      <Footer />
    </div>
  );
}